module.exports = {
    api: window.location.origin.match(/\/localhost:/)
      // ? 'http://b2b.test/api/v1/'
      // ?  'https://b2b-rt-test.ambitas.sk/api/v1/'
      ? 'https://b2b.ravaltrade.sk/api/v1/'
      :  '/api/v1/',
    api_postman: 'https://e9a9b093-1ca3-4209-a62e-6e58a1caef15.mock.pstmn.io/'
}



// WEBPACK FOOTER //
// ./src/global/index.js